<template>
   <section class="header-top">
      <div class="contenedor">
        <h1>90 DAYS MONEY BACK GUARANTEE</h1>
      </div>
    </section>
    <header>
      <div class="contenedor lg">
        <div id="multicolumns_header">
          <div>           
            <div >
              <ul class="stars">
                <li><a href="#cajas"> <i class="fa fa-star"></i></a></li>
                <li><a href="#cajas"> <i class="fa fa-star"></i></a></li>
                <li><a href="#cajas"> <i class="fa fa-star"></i></a></li>
                <li><a href="#cajas"> <i class="fa fa-star"></i></a></li>
                <li><a href="#cajas"> <i class="fa fa-star"></i></a></li>    
              </ul>
                <p class="text_star">AVARAGE REVIEWS RATING OF 4.7 OUT OF 5</p>
            </div>
            <div>
              <img src="img/Layer1045.png" alt="">
            </div>
            <div class="header_nav">
              <nav>
                <ul>
                  <li class="actual"><a href="index.html">Benefits</a></li>
                  <li><a href="#cajas">Reviews</a></li>
                  <li><a href="#cajas">Guarantee</a></li>
                  <li><a href="#cajas">FAQ</a></li>
                  <li><a href="#cajas"> <i class="fa-solid fa-cart-shopping"></i></a></li>                  
                </ul>
              </nav>
            </div>
          </div>
        </div>    
      </div>
    </header>

      <section id="hero">
        <div class="contenedor">
          <div class="contenedor1">
            <div id="multicolumns_hero">
              <div class="img_hero" >
                <img src="img/LEFT.png" width="550px" alt="">      
              </div>
              <div >
                <h2>An Effective Way For <span> Rapid<br> Ketosis & Wight Management</span></h2>
                  <ul class="text_hero">         
                    <li><i class="fa-solid fa-check"></i>Increases blood ketone levels</li>
                    <li><i class="fa-solid fa-check"></i>Helps to achieve ketosis</li>
                    <li><i class="fa-solid fa-check"></i>May help with weight loss</li>
                    <li><i class="fa-solid fa-check"></i>Reduces the amount of time to reach ketosis</li>
                </ul>
                <div class="btn_container">
                  <a class="btn">
                    <i class="fa-solid fa-hand-point-right"></i>
                    GET YOURS TODAY
                  </a>
                </div>
                <div class="banner_banks" >
                  <img src="img/Group115.png" alt="">
                </div>
                <div class="text_hero_p">
                <p>“Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed est vehicula, 
                  tempor lorem eu, sodales lacus. Morbi a luctus orci. Suspendisse potenti. Nulla ullamcorper quis dolor et rhoncus.”</p>
                </div>
                <div class="unit">
                  <div class="unit-left">
                      <img src="img/Layer1123.png" alt="">
                  </div>
                  <div class="unit-body">
                    <h6 class="star_personal">
                      <cite>Harry R. </cite><span><i class="fa-solid fa-circle-check"></i>  Verified Buyer</span>
                    </h6>
                    <ul class="star_score">
                      <li><a href="contacto.html"> <i class="fa fa-star"></i></a></li>
                      <li><a href="contacto.html"> <i class="fa fa-star"></i></a></li>
                      <li><a href="contacto.html"> <i class="fa fa-star"></i></a></li>
                      <li><a href="contacto.html"> <i class="fa fa-star"></i></a></li>
                      <li><a href="contacto.html"> <i class="fa fa-star"></i></a></li>
                    </ul>             
                  </div>          
                </div>
            </div>
            </div>
          </div>
        </div>
      </section> 

      <section id="enterprise">
        <div class="contenedor">
         
          <div class="top-wrap-brand owl-carousel owl-theme">
            <div class="top-brand-box" style="display:block !important ;">
              <img src="img/Asfeaturedon.png" style="padding-top: 10px;" alt="">
            </div>
            <div class="top-brand-box">
              <img src="img/Layer1158.png" height="40px" width="120px"  alt="">
            </div>
            <div class="top-brand-box">
              <img src="img/Layer1159.png"  height="50px" width="120px"   alt="">
            </div>
            <div class="top-brand-box">
              <img src="img/Layer1160.png" height="40px" width="120px"  alt="">
            </div>
            <div class="top-brand-box">
              <img src="img/Layer1161.png" height="40px" width="120px"  alt="">
            </div>
            <div class="top-brand-box">
              <img src="img/Layer1162.png" height="40px" width="120px"  alt="">
            </div>

          </div>
         </div> 
      </section>

      <section id="cajas" >
        <div class="contenedor md">
          <div>
            <h1 class="text_blue">
              Our Keto+ Drops and Keto+ BHB <br> Bundle Helps You To...
            </h1>
          </div>
          <div id="multicolumns">
              <div>
                <img src="img/Layer1164.png">
                <h3>Suppress Appetite</h3>
              </div>
              <div>
                <img src="img/Layer1052.png">
                <h3>Boost Metobolism</h3>
              </div>
              <div>
                <img src="img/Layer1164.png">
                <h3>Encourgae Ketosis</h3>
              </div>
          </div>  
          <div class="btn_container_hero">
            <a class="btn2" href=""><i class="fa-solid fa-hand-point-right"></i> GET YOURS TODAY</a>
          </div> 
        </div>
      </section>

      <section id="section_essrential"  class="esstential" >
        <div class="contenedor md">
          <div>
            <h1 class="text_white">
              An Essential Element in <span>Rapid <br> Ketosis & Weight Management</span>
            </h1>
          </div>
          <div id="multicolumns_essential">
              <div>
                <p>
                  There sure is a lot of hype around the trendy ketogenic diet on 
                  the Internet right now. The ketogenic diet is high in fat and low in carbohydrates. It boasts several benefits, including weight loss. Many people also experience improved heart health and enhanced brain function. The downside? The ketogenic diet isn’t necessarily easy to follow. You might need an extra boost.
                </p>
              </div>
              <div>
              <p>
                This Bundle product is a highly-recommended addition to your diet as well as a potent solution to getting down to your desired weight and achieving the body you want 
                in the healthiest and most effective way possible. By taking Keto+ BHB Salts and Keto+ Drops, you too can have your own weight loss journey success story minus the painful and grueling process.
              </p>
            
              </div>
          </div>  
          <div class="btn_container_hero">
            <a class="btn2" href=""><i class="fa-solid fa-hand-point-right"></i> GET YOURS TODAY</a>
          </div>
        </div>
      </section>
      
      <section id="cajas">
        <div class="contenedor_product">
          <div>
            <h2 class="text_blue">
              Using a combination of <span>premium-quality ingredients</span>, <br>
              the Keto+ BHB Salts and Keto+ Drops work to encourage rapid <br>
                ketosis, boosting metabolism and promoting better digestion.
            </h2>
          </div>
          <div class="container_owl">
            <div class="card-thumb-ingredients owl-carousel owl-theme">
              <div class="thumb-item">
                <div class="card">
                <img src="img/Layer1169.png" alt="eMAM Cloud" />
                <h3>GRAPEFRUIT POWDER</h3>
                <p>Fiber and water properties promote fullness and appetite control which can reduce calorie intake; low in calories and high in nutrients.</p>
                </div>
              
              </div>
              <div class="thumb-item">
                <div class="card">
                  <img src="img/Layer1167.png" alt="eMAM Cloud" />
                </div>
                <h3>RASPBERRY KETONE</h3>
                <p>Breaks down the fat within cells more effectively, helping your body burn fat faster, and increases levels of adiponectin, a hormone that helps regulate metabolism</p>
              </div>
              <div class="thumb-item">
                <div class="card">
                  <img src="img/Layer1169.png" alt="eMAM Cloud" />
                </div>
                <h3>GRAPEFRUIT POWDER</h3>
                <p>Fiber and water properties promote fullness and appetite control which can reduce calorie intake; low in calories and high in nutrients.</p>
              </div>
              <div class="thumb-item">
                <div class="card">
                  <img src="img/Layer1169.png" alt="eMAM Cloud" />
                </div>
                <h3>GRAPEFRUIT POWDER</h3>
                <p>Fiber and water properties promote fullness and appetite control which can reduce calorie intake; low in calories and high in nutrients.</p>
              </div>
            </div>
          </div>
            <div class="btn_container_hero">
              <a class="btn2" href=""> <i class="fa-solid fa-hand-point-right"></i> GET YOURS TODAY</a>
            </div>
          </div>    
     
      </section>

      <section id="section_90"  class="esstential" >
        <div class="contenedor md">
          <div id="section_banner">
            <div>
              <img src="img/Layer1046.png" width="120px" height="120px" alt="">         
            </div>
              <div>
                <H3>100% Satisfaction Guaranteed</H3>
                <p>
                  Try Reagan Health pproducts risk dree for 90 days. If you're not <br>
                  fully satisfied, we will give you a 100% hassle-free refund.
                </p>
              </div>       
          </div>  
        </div>
      </section>

      <section id="cajas">
          <div class="contenedor md-l">
            <div>
              <h1 class="text_blue">
                How Do Keto+ Drops and Keto+ BHB Work
              </h1>
            </div>
            <div id="multicolumns_circle" class="circle_tex">
                <div>
                  <figure id="circle"><p>1</p></figure>
                  <h3>Support</h3>
                  <p class="circle_text">Supports keto diets by helping induce rapid ketosis and ensuring that your body stays in ketosis, effectively utilizing fat to create energy fuel.
                  </p>
                </div>
                <div>
                  <figure id="circle"><p>2</p></figure>
                  <h3>Boots</h3>
                  <p class="circle_text">Boosts metabolism, effectively burning carbs and utilizing fat buildup in unwanted areas, creating energy and building stamina.
                  </p>
                </div>
                <div>
                  <figure id="circle"><p>3</p></figure>
                  <h3>Manage</h3>
                  <p class="circle_text">Manages the negative side effects of a ketogenic diet, such as the keto flu, which includes symptoms like constipation, headaches, bad breath, muscle cramps, and diarrhea.</p>
                </div>
                <div>
                  <figure id="circle"><p>4</p></figure>
                  <h3>Improve</h3>
                  <p class="circle_text">Improves focus and cognitive function, and enhances athletic performance by giving you that much-needed energy boost on the daily.</p>
                </div>
            </div>  
            <div class="btn_container_hero">
              <a class="btn2" href=""><i class="fa-solid fa-hand-point-right"></i> GET YOURS TODAY</a>
            </div>
            
            
        
      
          </div>
      </section>

      <section id="section_product">
        <div class="contenedor_product">
            <div>
              <h1 style="text-align: center ;">
                Hundreds Of Are Raving About Their Results
              </h1>
            </div>
            <div class="container_owl">
              <div class="card-thum-ref owl-carousel owl-theme">
                <div class="thumb-item-ref">
                  <img src="img/Layer1123.png" alt="John" width="60px" height="60px">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed est vehicula, tempor lorem eu, sodales lacus. Suspendisse potenti. Nulla ullamcorper quis dolor et rhoncus.”</p>
                    <div class="star_ref">
                      <a href="contacto.html"> <i class="fa fa-star"></i></a>
                      <a href="contacto.html"> <i class="fa fa-star"></i></a>
                      <a href="contacto.html"> <i class="fa fa-star"></i></a>
                      <a href="contacto.html"> <i class="fa fa-star"></i></a>
                      <a href="contacto.html"> <i class="fa fa-star"></i></a>
                    </div>
                    <p id="title">RUSS K. <i class="fa-solid fa-circle-check"></i> verified Buyer</p>   
                </div>
                <div class="thumb-item-ref">
                  <img src="img/Layer1123.png" alt="John" width="60px" height="60px">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed est vehicula, tempor lorem eu, sodales lacus. Suspendisse potenti. Nulla ullamcorper quis dolor et rhoncus.”</p>
                      <div class="star_ref" >
                        <a href="contacto.html"> <i class="fa fa-star"></i></a>
                        <a href="contacto.html"> <i class="fa fa-star"></i></a>
                        <a href="contacto.html"> <i class="fa fa-star"></i></a>
                        <a href="contacto.html"> <i class="fa fa-star"></i></a>
                        <a href="contacto.html"> <i class="fa fa-star"></i></a>
                      </div>
                    <p id="title">RUSS K. <i class="fa-solid fa-circle-check"></i> verified Buyer</p>      
                </div>
                <div class="thumb-item-ref">
                  <img src="img/Layer1123.png" alt="John" width="60px" height="60px">
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed est vehicula, tempor lorem eu, sodales lacus. Suspendisse potenti. Nulla ullamcorper quis dolor et rhoncus.”</p>
                    <div class="star_ref">
                      <a href="contacto.html"> <i class="fa fa-star"></i></a>
                      <a href="contacto.html"> <i class="fa fa-star"></i></a>
                      <a href="contacto.html"> <i class="fa fa-star"></i></a>
                      <a href="contacto.html"> <i class="fa fa-star"></i></a>
                      <a href="contacto.html"> <i class="fa fa-star"></i></a>
                    </div>
                  <p id="title">RUSS K. <i class="fa-solid fa-circle-check"></i> verified Buyer</p>          
                </div>
                <div class="thumb-item-ref">
                  <img src="img/Layer1123.png" alt="John" width="60px" height="60px">
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed est vehicula, tempor lorem eu, sodales lacus. Suspendisse potenti. Nulla ullamcorper quis dolor et rhoncus.”</p>
                    <div class="star_ref">
                      <a href="contacto.html"> <i class="fa fa-star"></i></a>
                      <a href="contacto.html"> <i class="fa fa-star"></i></a>
                      <a href="contacto.html"> <i class="fa fa-star"></i></a>
                      <a href="contacto.html"> <i class="fa fa-star"></i></a>
                      <a href="contacto.html"> <i class="fa fa-star"></i></a>
                    </div>
                  <p id="title">RUSS K. <i class="fa-solid fa-circle-check"></i> verified Buyer</p> 
                </div>
              </div>
            </div>
              <div class="btn_container_hero">
                <a class="btn2" href=""><i class="fa-solid fa-hand-point-right"></i> GET YOURS TODAY</a>
              </div>
          </div>
    
      </section>

      <section class="section_parners" id="cajas" >
        <div class="contenedor md-l">
          <div>
            <h1 class="text_blue">
              Regen Health Products Are Always...
            </h1>
          </div>
          <div id="multicolumns_circle">
              <div>
                <img src="img/Layer1171.png" width="90px" height="95px" alt="">
                <h3>Made in America</h3>
                <p>We are proud that ALL Regen Health products are made in the USA. The well-being of our customers is our highest priority.</p>
              </div>
              <div>
                <img src="img/Layer1172.png" width="90px" height="95px" alt="">
                <h3>GMP Certified</h3>
                <p>All products distributed and manufactured by Regen Health are manufactured in a GMP-certified facility. Regen Health ensures that all of their products are consistently produced to the highest quality.</p>
              </div>
              <div>
                <img src="img/Layer1173.png" width="150px" height="95px" alt="">
                <h3>FDA Approved</h3>
                <p>All products distributed and manufactured by Regen Health are manufactured in a facility that is approved by the U.S. Food and Drug Administration(FDA). </p>
              </div>
              <div>
                <img src="img/NATURAL_INGREDIENTS.png" width="90px" height="95px" alt="">
                <h3>All Natural</h3>
                <p>Regen Health absolutely does not use filler ingredients and other harmful chemicals or additives in their products. This promise ensures each product’s purity, and safety for use and consumption.</p>
              </div>
          </div>  
          <div class="btn_container_hero">
            <a class="btn2" href=""><i class="fa-solid fa-hand-point-right"></i> GET YOURS TODAY</a>
          </div>  
        </div>
      </section>

      <section id="cajas" >
        <div class="contenedor md-l">
          <div>
            <h1 class="text_blue">
              Questions? We're Got You Covered!
            </h1>
          </div>
          <label class="accordion-wrapper">
            <input type="checkbox" class="accordion" hidden />
            <div class="title">
              <strong>Does it work?</strong> 
              <i class="fa-solid fa-sort-down side-icon"  title="angle-right" ></i>
              <i class="fa fa-check down-icon"  title="angle-down"></i>
            
            </div>
            <div class="content">
              <p>Content</p>
            </div>
          </label>
          <label class="accordion-wrapper">
            <input type="checkbox" class="accordion" hidden />
            <div class="title">
              <strong>Is it harmful?</strong> 
              <i class="fa-solid fa-sort-down side-icon"  title="angle-right"></i>
              <i class="fa fa-check down-icon"  title="angle-down"></i>
            
            </div>
            <div class="content">
              <p>Content</p>
            </div>
          </label>
          <label class="accordion-wrapper">
            <input type="checkbox" class="accordion" hidden />
            <div class="title">
              <strong>How long does the shipping take?</strong>
              <i class="fa-solid fa-sort-down side-icon"  title="angle-right"></i>
              <i class="fa fa-check down-icon"  title="angle-down"></i>
            
            </div>
            <div class="content">
              <p>Content</p>
            </div>
          </label>
          <label class="accordion-wrapper">
            <input type="checkbox" class="accordion" hidden />
            <div class="title">
              <strong>Is there are shipping cost?</strong>
              <i class="fa-solid fa-sort-down side-icon"  title="angle-right"></i>
              <i class="fa fa-check down-icon"  title="angle-down"></i>
            
            </div>
            <div class="content">
              <p>Content</p>
            </div>
          </label>
          <label class="accordion-wrapper">
            <input type="checkbox" class="accordion" hidden />
            <div class="title">
              <strong>How soon can i expect results?</strong>
              <i class="fa-solid fa-sort-down side-icon"  title="angle-right"></i>
              <i class="fa fa-check down-icon"  title="angle-down"></i>
            
            </div>
            <div class="content">
              <p>Content</p>
            </div>
          </label>
        </div>
      </section>

    <footer>
      <div class="contenedor lg">
        <div id="multicolumns_header">
          <div>
            
            <div class="text_star" style="color: black;">
                <p>© Copyright 2020. Regen Health</p>
            </div>
            <div>
              <img src="img/Layer1045.png" alt="">
            </div>
            <div class="footer">
             
                <ul>
                  <li ><a href="#cajas">Terms & Conditions</a></li>
                  <li><a href="#cajas"> Privacy Policy</a></li>
                  
                  
                </ul>
              
            </div>
          </div>
        </div>
       
      
      </div>
    </footer>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
